/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const es_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const de_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const nl_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const fr_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID`)
};

const it_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID`)
};

const pt_br2_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const pt_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDs`)
};

const ja_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID`)
};

const zh_rg_mode_uuid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_mode_uuid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_mode_uuid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_mode_uuid", locale)
	if (locale === "en") return en_rg_mode_uuid(inputs)
	if (locale === "es") return es_rg_mode_uuid(inputs)
	if (locale === "de") return de_rg_mode_uuid(inputs)
	if (locale === "nl") return nl_rg_mode_uuid(inputs)
	if (locale === "fr") return fr_rg_mode_uuid(inputs)
	if (locale === "it") return it_rg_mode_uuid(inputs)
	if (locale === "pt-BR") return pt_br2_rg_mode_uuid(inputs)
	if (locale === "pt") return pt_rg_mode_uuid(inputs)
	if (locale === "ja") return ja_rg_mode_uuid(inputs)
	return zh_rg_mode_uuid(inputs)
};